export function checkPermissions(profile, access) {
    return (profile?.userType === 'admin' && profile?.subAdmin === true && profile?.subAdminAccesses?.includes(access))
        || profile?.userType === 'master'
        || (profile?.userType === 'admin' && profile?.subAdmin === false);
}